import * as React from 'react';

function SvgBinDeleteEmpty(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7 7.047V5.7h4.513v1.347H12.7zm-1.4 0V5a.7.7 0 01.7-.7h5.913a.7.7 0 01.7.7v2.047h2.967c.033 0 .065.002.097.006a.704.704 0 01.096-.006h2.354a.7.7 0 110 1.4H22.28v15.88a.7.7 0 01-.7.7H7.813a.7.7 0 01-.7-.7V8.447H5.5a.7.7 0 010-1.4h2.14c.03 0 .058.001.086.005a.706.706 0 01.087-.005H11.3zm-2.787 16.58H20.88V8.447H8.513v15.18z"
        fill={props.fill ? props.fill : '#414B56'}
      />
    </svg>
  );
}

export default SvgBinDeleteEmpty;
